import { ColumnActionsMode } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import { commonColumnProps } from 'common/utils/columnUtilities';



const useColumns = () => {
  const columns: ColumnData[] = [
    {
      key: 'notifyType',
      name: 'Type',
      fieldName: 'notifyType',
      minWidth: 250,
      maxWidth: 250,
      ...commonColumnProps,
    },
    {
      key: 'timeZone',
      name: 'Time Zone',
      fieldName: 'timeZone',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
      columnActionsMode: ColumnActionsMode.disabled,
    },
    {
      key: 'sentOnDays',
      name: 'Sent on Days',
      fieldName: '',
      minWidth: 430,
      maxWidth: 430,
      ...commonColumnProps,
      columnActionsMode: ColumnActionsMode.disabled,
    },
    {
      key: 'startSendTime',
      name: 'Cycle Start Time',
      fieldName: 'startSendTime',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
      columnActionsMode: ColumnActionsMode.disabled,
    },
    {
      key: 'endSendTime',
      name: 'Cycle End Time',
      fieldName: 'endSendTime',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
      columnActionsMode: ColumnActionsMode.disabled,
    },
    {
      key: 'lastRun',
      name: 'Last Run',
      fieldName: 'lastRun',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
    },
    {
      key: 'action',
      name: 'Actions',
      fieldName: 'action',
      minWidth: 50,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
      isResizable: false,
    },
  ];
  return { columns };
};
export { useColumns };
